export default __webpack_public_path__ + "static/media/Picture2.30f1f566.png";